import { FROM_MODULE_TYPE } from '@utils/constants'

export type ActivityType =
  | 'ITEM_VIEWING'
  | 'ITEM_EDITING'
  | 'ITEM_DETAIL_CLOSED'

export interface UserActivity {
  activityType: ActivityType
  createdTime: string
  fromModule: FROM_MODULE_TYPE
  objectId?: string
  tenantId?: string
  userId?: string
  user?: any
}

type NotificationDataReference = {
  fromModule: string
  objectId: string
  displayName?: string
}

export enum NotificationType {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  EMAIL_SENT = 'EMAIL_SENT',
}

export const NotificationTypeDisplayName = {
  [NotificationType.ACTION_REQUIRED]: 'Action Required',
  [NotificationType.EMAIL_SENT]: 'Email Received',
}

/** Backend template key on Xero upload failures (XeroNotificationKeys.UploadFailed in ICS_API). */
export const XERO_UPLOAD_FAILED_KEY = 'XERO_UPLOAD_FAILED'

/** Backend template key on PMS upload failures (PmsNotificationKeys.UploadFailed in ICS_API). */
export const PMS_UPLOAD_FAILED_KEY = 'PMS_UPLOAD_FAILED'

export type RealtimeNotificationData = {
  notificationId?: string
  title: string
  content: string
  type: NotificationType
  templateKey?: string
  createdTime?: string
  sentByUserId?: string
  reference?: NotificationDataReference
}
